import { useState } from 'react';
import type { CancelAgreementStep } from '../components/cancellation/CancelAgreementPanel/CancelAgreementPanel';
import type { CancelAgreementValues } from '../schemas/cancelAgreement.schema';
import { cancellationErrorMessage } from '../utils/cancellationError';
import { useCancelAgreement } from './useCancelAgreement';

export function useCancellationSteps(agreementId: string) {
    const [step, setStep] = useState<CancelAgreementStep>('details');
    const [serverError, setServerError] = useState<string | null>(null);
    const [started, setStarted] = useState(false);
    const { mutate, isPending } = useCancelAgreement(agreementId);

    const goTo = (next: CancelAgreementStep) => {
        setServerError(null);
        setStep(next);
    };

    const submit = (values: CancelAgreementValues) => {
        setServerError(null);
        mutate(values, {
            onSuccess: () => {
                setStarted(true);
                setStep('details');
            },
            onError: (error) => setServerError(cancellationErrorMessage(error)),
        });
    };

    return {
        step,
        pending: isPending,
        serverError,
        started,
        onContinue: () => goTo('confirm'),
        onBack: () => goTo('details'),
        onSubmit: submit,
    };
}
